import UnitDetails, {
    getServerSideProps as gSSP,
} from '@oberoninternal/travelbase-website/dist/components/pages/UnitDetail';
import React, { FC } from 'react';
import { GetStaticPaths, GetStaticProps } from 'next';
import addGlobalQuery from '../../utils/addGlobalQuery';
import Page from '@oberoninternal/travelbase-website/dist/components/Page';
import brandConfig from '../../constants/brandConfig';
import { DEFAULT_REVALIDATION_TIME } from '../../constants/revalidationTime';
import hasRedirect from '../../utils/hasRedirect';
import Promo from '../../components/Promo';
import ContentWrapper from '@oberoninternal/travelbase-website/dist/components/ContentWrapper';

const UnitDetailsNL: FC<React.PropsWithChildren<unknown>> = props => (
    <Page>
        <UnitDetails pageSlug="accommodatie" {...props} />
        <ContentWrapper>
            <Promo />
        </ContentWrapper>
    </Page>
);
export default UnitDetailsNL;

export const getStaticProps: GetStaticProps = async context => {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    let result = await gSSP(brandConfig, context as any);

    if ('notFound' in result) {
        const redirect = await hasRedirect(`accommodatie/${context.params?.slug}`, context.locale as string);

        if (redirect) {
            const { redirectDestUrl, redirectHttpCode } = redirect;
            result = {
                redirect: {
                    permanent: redirectHttpCode === 301,
                    destination: redirectDestUrl,
                },
            };
        }
    }

    return {
        ...(await addGlobalQuery(result, context.locale)),
        revalidate: DEFAULT_REVALIDATION_TIME,
    };
};

export const getStaticPaths: GetStaticPaths = async () => ({ paths: [], fallback: 'blocking' });
